/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useDispatch, useSelector } from 'react-redux';
import { View, Dimensions, ScrollView } from 'react-native';

import { buttonFloating, buttonRow } from '@/assets/styles/buttonStyles';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isAndroid } from '@global/screens';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import RadioButton from '@components/form/RadioButton';
import Input from '@components/form/Input';
import DatePicker from '@components/form/DatePicker';
import StatusPicker from '@components/form/StatusPicker';
import CheckBox from '@components/form/CheckBox';

import { showPopup } from '@/store/modal';
import {
  filterAdded,
  paginationAdded,
  paramsReseted,
  selectParams,
} from '@/store/params';
import { setFilterTemp } from '@/store/filter';
import { setSavedFilter } from '@global/helpers';

const dimension = Dimensions.get('window');
const defaultLimit = isWeb ? 10 : 15;

const SociollaFilter = (props) => {
  const testID = props.testID || 'sociolla-filter';
  const { data: filterData } = props;

  //const [list, setList] = useState({});
  const [filter, setFilter] = useState({});
  const [filterMongo, setFilterMongo] = useState({});
  // const [dateRangeChanged, setDateRangeChanged] = useState(false);
  const [filterChanged, setFilterChanged] = useState(false);

  const filterHash = {};
  const insets = useSafeAreaInsets();
  const filterHeight = isWeb
    ? 'auto'
    : dimension.height - insets.top - insets.bottom - (isAndroid ? 85 : 55);

  const dispatch = useDispatch();
  const filterName = props.filterName ? props.filterName : null;
  const paramsState = useSelector(selectParams(filterName)); // existing parameters for filter
  const filterTemp = useSelector((state) => state.filter.filterTemp);

  // const filterChanged = useMemo(() => {
  //   if (dateRangeChanged) {
  //     return true;
  //   }
  //   const params =
  //     (paramsState.filter && Object.entries(paramsState.filter).length) || 0;
  //   const filter = Object.entries(filterMongo).length;
  //   if (params !== filter) {
  //     return true;
  //   }
  //   let changed = false;
  //   if (params > 0) {
  //     for (const [key, value] of Object.entries(paramsState.filter)) {
  //       changed = !(filterMongo[key] && filterMongo[key] === value);
  //     }
  //   }
  //   return changed;
  // }, [paramsState.filter, filterMongo, dateRangeChanged]);

  const initialFilter = async (data) => {
    const newFilter = JSON.parse(JSON.stringify(filter));
    data.forEach((dt) => {
      // setList({
      //   ...list,
      //   [dt.filter.type]: dt,
      // });
      if (dt.filter.type === 'daterange') {
        const listDate = {};
        dt.filter.filter.forEach((dtt) => {
          listDate[dtt.key] = {
            options: '',
            value: '',
          };
        });
        newFilter['daterange'] = listDate;
        filterHash['daterange'] = dt;
      } else if (dt.filter.type === 'checkbox') {
        newFilter[dt.filter.filter] = {
          options: '',
          value: [],
        };
        filterHash[dt.filter.filter] = dt;
      } else {
        newFilter[dt.filter.filter] = {
          options: '',
          value: '',
        };
        filterHash[dt.filter.filter] = dt;
      }
    });
    await setFilter({
      ...newFilter,
    });
    return newFilter;
  };

  const setFilterData = (data, index, type, value, opt) => {
    try {
      let newValue = value;
      let filterKey = data.filter.filter;
      if (data.filter.type === 'picker') {
        newValue = value.value;
      } else if (data.filter.type === 'daterange') {
        newValue = new Date(value).toISOString();
        filterKey = data.filter.type;
        type = opt.key;
        newValue = { options: opt.options, value: newValue };
        if (filterTemp?.daterange) {
          setFilterChanged(
            Boolean(filterTemp.daterange[filterKey] !== newValue),
          );
        }
      }
      if (filter[filterKey] != newValue) {
        // console.log('filter', filterKey, filter[filterKey], newValue)
        setFilterChanged(true);
      }
      setFilter({
        ...filter,
        [filterKey]: {
          ...filter[filterKey],
          [type]: newValue || '',
        },
      });
    } catch (e) {
      console.log(e);
    }
  };

  const apply = (reset = false) => {
    try {
      if (reset) {
        dispatch(paramsReseted());
      } else {
        dispatch(
          paginationAdded({
            skip: 0,
            limit: paramsState.limit || defaultLimit,
          }),
        );
        dispatch(filterAdded(filterMongo));
        setSavedFilter({ filters: filterMongo });
      }
      dispatch(setFilterTemp(filter));
      dispatch(showPopup({ name: 'sociollaFilter', value: false }));
    } catch (e) {}
  };

  const convertToMongoQuery = () => {
    let result = {};
    for (const [key, value] of Object.entries(filter)) {
      if (key === 'daterange') {
        const dr = [];
        let valid = true;
        for (const [key2, value2] of Object.entries(value)) {
          if (!value2.value) {
            valid = false;
          }
          dr.push({ ...getValue(key2, value2) });
        }
        if (valid) {
          result = {
            ...result,
            $and: dr,
          };
        }
      } else {
        let values = value.value;
        if (
          filterHash[key]?.filter?.dataType &&
          filterHash[key].filter.dataType === 'Boolean'
        ) {
          values = value.value === 'true' ? true : false;
        }
        if (values && Array.isArray(values)) {
          values = [];
          for (let index = 0; index < value.value.length; index++) {
            values.push(value.value[index].value);
          }
        }
        result = {
          ...result,
          ...getValue(key, { ...value, value: values }),
        };
      }
    }
    setFilterMongo(result);
  };

  const convertToFilter = (data) => {
    const filters = JSON.parse(JSON.stringify(paramsState.filter));
    const newFilters = data;
    for (const [key, value] of Object.entries(filters)) {
      let values = value;
      if (
        filterHash[key]?.filter?.dataType &&
        filterHash[key].filter.dataType === 'Boolean'
      ) {
        values = value === true ? 'true' : 'false';
      }
      newFilters[key] = {
        options: data[key]?.options || '',
        value: values,
      };
    }
    setFilter({
      ...newFilters,
    });
  };

  const getValue = (key, value) => {
    if (value.value) {
      let values = value.value;
      if (Array.isArray(values)) {
        if (values.length) {
          values = { $in: value.value };
        } else {
          return {};
        }
      } else {
        if (value.options) {
          values = { [value.options]: value.value };
        }
      }
      return { [key]: values };
    }
    return {};
  };

  const getOptions = (data, index) => {
    if (data.filter.actionType === 'radio' && data.filter.actions.length) {
      return (
        <RadioButton
          orientation="vertical"
          value={filter[data.filter.filter].options}
          onChange={(value) => setFilterData(data, index, 'options', value)}
          data={data.filter.actions}
        />
      );
    }
    return <></>;
  };

  const getInput = (data, index) => {
    if (data.filter.type === 'daterange') {
      return data.filter.filter.map((dt, idx) => {
        {
          return (
            <View
              key={'list-' + dt.key + '-' + idx}
              style={{ marginRight: idx > 1 ? 0 : 16, flex: 1 }}>
              <DatePicker
                label={dt.label}
                iconStyle={{
                  marginRight: 0,
                  marginLeft: isMobileWeb ? -70 : 0,
                }}
                value={filter['daterange'][dt.key].value}
                onChange={(value) =>
                  setFilterData(data, index, 'value', value, dt)
                }
              />
            </View>
          );
        }
      });
    } else if (data.filter.type === 'number') {
      return (
        <Input
          value={filter[data.filter.filter].value}
          onChangeText={(value) => setFilterData(data, index, 'value', value)}
          label={'Input ' + data.filter.label}
        />
      );
    } else if (data.filter.type === 'picker') {
      return (
        <StatusPicker
          options={data.filter.list}
          labelKey="label"
          trackBy="value"
          value={filter[data.filter.filter].value}
          onChange={(value) => setFilterData(data, index, 'value', value)}
        />
      );
    } else if (data.filter.type === 'checkbox') {
      return (
        <CheckBox
          options={data.filter.list}
          labelKey="label"
          trackBy="value"
          isMultiple={true}
          totalColumn={isWeb ? 2 : 1}
          value={filter[data.filter.filter].value}
          onChange={(value) => setFilterData(data, index, 'value', value)}
        />
      );
    }
    return <></>;
  };

  useEffect(() => {
    initialFilter(filterData).then((res) => {
      if (paramsState.filter && Object.entries(paramsState.filter).length) {
        if (filterTemp && Object.keys(filterTemp).length) {
          setFilter(filterTemp);
        } else {
          convertToFilter(res);
        }
      }
    });
  }, []);

  useEffect(() => {
    convertToMongoQuery();
  }, [filter]);

  return (
    <View
      testID={testID}
      style={{
        width: '100%',
        height: filterHeight,
        marginTop: isWeb ? 0 : 10,
        maxHeight: isWeb ? dimension.height - 100 : dimension.height,
      }}>
      <ScrollView contentContainerStyle={{ paddingBottom: 30 }}>
        <View style={{ paddingHorizontal: 30, marginVertical: 10 }}>
          {filter &&
            Object.entries(filter).length > 0 &&
            filterData.map((dt, idx) => {
              return (
                <View
                  style={[
                    idx + 1 < filterData.length
                      ? {
                          borderBottomColor: '#ededee',
                          borderBottomWidth: 1,
                          paddingBottom: 20,
                        }
                      : {},
                    { marginBottom: 20 },
                  ]}
                  key={'list-filter-' + idx}>
                  <SociollaText
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.black,
                      marginBottom: 10,
                    }}>
                    {dt.filter.label}
                  </SociollaText>
                  {getOptions(dt, idx)}
                  <View
                    style={[
                      { marginTop: 15 },
                      dt.filter.type === 'daterange'
                        ? { flexDirection: 'row', width: '100%' }
                        : {},
                    ]}>
                    {getInput(dt, idx)}
                  </View>
                </View>
              );
            })}
        </View>
      </ScrollView>
      <View
        style={[
          buttonRow,
          isWeb
            ? { padding: 15 }
            : {
                ...buttonFloating,
                paddingHorizontal: 15,
                paddingTop: 15,
                paddingBottom: 10,
              },
          { width: '100%', justifyContent: 'center', bottom: 0 },
        ]}>
        <Button
          testID={`${testID}-reset-btn`}
          type="default"
          rounded
          buttonStyle={{
            ...(isWeb
              ? { marginHorizontal: 10, width: 150 }
              : {
                  width: isMobileWeb
                    ? Math.round(dimension.width / 2) - 20
                    : '90%',
                  alignSelf: 'center',
                  marginRight: isMobileWeb ? 10 : 0,
                }),
          }}
          title={
            <SociollaText
              type="bold"
              style={{ fontSize: 14, color: Colors.black }}>
              Reset
            </SociollaText>
          }
          onPress={() => apply(true)}
        />
        <Button
          testID={`${testID}-apply-btn`}
          rounded
          buttonStyle={{
            ...(isWeb
              ? { marginHorizontal: 10, width: 150 }
              : {
                  width: isMobileWeb
                    ? Math.round(dimension.width / 2) - 20
                    : '90%',
                  alignSelf: 'center',
                }),
          }}
          title={
            <SociollaText
              type="bold"
              style={{ fontSize: 14, letterSpacing: 0.5, color: Colors.white }}>
              Apply
            </SociollaText>
          }
          disabled={!filterChanged}
          disabledStyle={{
            width: isWeb
              ? 150
              : isMobileWeb
              ? Math.round(dimension.width / 2) - 20
              : '90%',
          }}
          onPress={() => apply()}
        />
      </View>
    </View>
  );
};

export default SociollaFilter;
